module.exports = __webpack_public_path__ + "static/media/vip-hour-tile-2stars.a92789e4.png";